import { Employee } from './employee';
import { Member } from './member';
import { Merchant } from './merchant';
import { Location } from './location';
import { Timestamp } from '@firebase/firestore-types';
import { Chat } from './chat';
import { OrderLocation } from './order_location';
import { RecentChat } from './recent_chats';
import { LineItems } from './transaction';
import { Items } from './cart';

export interface Order {
    id?: string;
    customer_id?: any;
    customer?: Member;
    merchant?: Merchant;
    location_id?: any;
    created_at?: Timestamp;
    order_date?: Timestamp;
    updated_at?: Timestamp;
    pickup_at?: Timestamp;
    pickup_day?: string;
    no_of_items?: string;
    no_of_bags?: string;
    // proof_of_delivery?: string;
    assigned_employee?: any;
    assigned_employee_object?: Employee;
    chat?: RecentChat;
    status?: string; //open/arrived/in_progress/complete
    sub_status?: string; //received/ready for pickup/checkedin/customer arrived/ack/worker assigned
    customer_status?: string; //on my way/checked-in
    location?: Location;
    merchant_id?: string;
    member_vehicle?: Vehicle;
    external_order_id?:string;
    customer_status_updated_at?: Timestamp;
    order_status_updated_at?: Timestamp;
    pickup_protocol?: PickupProtocol;
    eta_object?: OrderLocation;
    waiting_time?: String;
    instructions?: String;
    currency?: string;
    amount?: number;
    item_details?: string;
    paid?: boolean;
    // collect_tax?: boolean;
    order_files?: OrderFile[];
    transaction_id?: string;
    order_channel?: string; // customer, merchant, app, cp
    application_fee?: number; // temporary,
    paid_via?: PaidVia;
    type?:string; //dine_in, pick_up
    table_id?:string;
    line_items?: LineItems[];
    items?: Items[];
    invoice_id?:string;
    charge_from?: "merchant"| "customer";
}

export type CurrencyType = 'usd' | 'inr' | 'gbp' | 'cad'

export type PaidVia = 'cash' | 'card' | 'pay_later';

export interface OrderFile {
  name?: string;
  url?: string;
}

export interface PickupProtocol {
  on_my_way?: Status;
  checked_in?: Status;
  check_in_acknowledged?: Status;
  worker_assigned?: Status;
  employee_on_my_way?: Status;
  delivery_complete?: Status;
  delivery_complete_acknowledged?: Status;
  proof_of_delivery?: ProofOfDelivery;
  knock_knock?: KnockKnock;
}

export interface KnockKnock{
  counter?: number;
  status?: boolean;
  updated_at?: Timestamp;
}
export interface Status {
  status?: boolean;
  updated_at?: Timestamp;
}

export interface ProofOfDelivery{
  photo_url?: string[];
  updated_at?: Timestamp;
}

//field names enum
export enum OrderStatus {
  ACTIVE = 'active',
  READY = 'ready',
  COMPLETED = 'completed'
}

export enum OrderSubStatus {
  RECEIVED = 'received', //for display use 'new order' for member, use 'received' for merchant
  PREPARING = 'preparing',//for display use 'preparing' for member, use 'preparing' for merchant
  READY_FOR_PICKUP = 'ready_for_pickup',
  PICKUP_IN_PROGESS = 'pickup_in_progress',
  COMPLETE = 'complete',
  CANCEL = 'cancel'
}

export enum CustomerStatus {
  NA = 'NA',
  ON_MY_WAY = 'on_my_way',
  CHECKED_IN = 'checked_in'
}

export interface Vehicle {
  plate_number?: string;
  type?: string;
  model?: string;
  make?: string;
  color?: string;
  photo_url?: string;
  is_primary?: boolean; 
}
// export enum OrderSubStatus {
//     //TODO: Add sub statuses
// }


export function initializeProofOfDelivery() {
  return {
      on_my_way: {
          status: false,
          updated_at: null
      },
      checked_in: {
          status: false,
          updated_at: null
      },
      check_in_acknowledged: {
          status: false,
          updated_at: null
      },
      worker_assigned: {
          status: false,
          updated_at: null
      },
      employee_on_my_way: {
          status: false,
          updated_at: null
      },
      knock_knock: {
          counter: 0,
          status: false,
          updated_at: null
      },
      proof_of_delivery: {
          photo_url: [],
          updated_at: null
      },
      delivery_complete: {
          status: false,
          updated_at: null
      },
      delivery_complete_acknowledged: {
          status: false,
          updated_at: null
      }
  }
}